import {createClient, SupabaseClient} from '@supabase/supabase-js';
import ConfigService from './configService';

let supabaseClient: SupabaseClient | null = null;

export const getSupabaseClient = (): SupabaseClient => {
  if (!supabaseClient) {
    const url = ConfigService.supabaseUrl;
    const anonKey = ConfigService.supabaseAnonKey;

    supabaseClient = createClient(url, anonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true, // Activer pour détecter la session OAuth dans l'URL après redirect
      },
    });
  }

  return supabaseClient;
};

export default getSupabaseClient;
